<div class="td-page">

  <!-- ─── NOT FOUND ─── -->
  <section class="td-empty-section" *ngIf="notFound">
    <div class="td-empty-icon">
      <i class="fas fa-box-open"></i>
    </div>
    <h2 class="td-empty-title">Spedizione non trovata</h2>
    <p class="td-empty-code">#{{ trackingCode }}</p>
    <p class="td-empty-sub">Nessuna spedizione corrisponde a questo codice. Verifica che il codice sia corretto e riprova.</p>
    <button class="td-empty-btn" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      Nuova ricerca
    </button>
  </section>

  <!-- ─── ERROR ─── -->
  <section class="td-empty-section" *ngIf="loadError">
    <div class="td-empty-icon td-empty-icon--error">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h2 class="td-empty-title">Errore di connessione</h2>
    <p class="td-empty-sub">Non è stato possibile recuperare i dati della spedizione. Controlla la connessione e riprova.</p>
    <button class="td-empty-btn" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      Torna alla ricerca
    </button>
  </section>

  <!-- ─── MAIN CONTENT ─── -->
  <ng-container *ngIf="!notFound && !loadError">

    <!-- ─── HEADER ─── -->
    <div class="td-header">
      <div class="sysmon-heading">
        <div class="sysmon-heading-icon td-heading-icon"><i class="fas fa-box"></i></div>
        <div>
          <h1 class="sysmon-title">Tracking spedizione</h1>
          <p class="sysmon-subtitle">#{{ waybills[0]?.waybillCode }}</p>
        </div>
      </div>
      <div class="sysmon-toolbar">
        <div class="countdown-chip" [class.paused]="isPaused">
          <i class="fa-regular fa-clock"></i>
          <span>Agg. in <strong>{{ countdown }}s</strong></span>
          <button class="countdown-toggle" (click)="toggleTimer()" [title]="isPaused ? 'Riprendi' : 'Pausa'">
            <i [class]="isPaused ? 'fas fa-play' : 'fas fa-pause'"></i>
          </button>
        </div>
        <button *ngIf="btnResetVisible" (click)="mostraDettagliSpedizione()" class="sysmon-btn sysmon-btn--secondary">
          <i class="fas fa-arrow-left"></i>
          Torna ai dettagli
        </button>
      </div>
    </div>

    <!-- ─── BODY ─── -->
    <div class="td-body">

      <!-- ── LEFT: routing table ── -->
      <div class="details-card td-left-card">
        <div class="details-card-header">
          <div class="details-card-icon"><i class="fas fa-route"></i></div>
          <h3 class="details-card-title">Percorso</h3>
        </div>
        <div class="sysmon-table-wrap">
          <table class="sysmon-table">
            <thead>
              <tr>
                <th class="th-icon-col"></th>
                <th>Punto di Transito</th>
                <th>Stato</th>
                <th>Data</th>
                <th>Ora</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let point of routingPoints" class="routing-row" (click)="showPointDetails(point)">
                <td class="td-icon-col">
                  <i [ngClass]="getStatusIconClasses(point.status)"></i>
                </td>
                <td class="td-strong">{{ point.titolo }}</td>
                <td>
                  <span class="sysmon-pill" [ngClass]="getStatusPillClass(point.status)">
                    {{ getStatusLabel(point.status) }}
                  </span>
                </td>
                <td>{{ point.data }}</td>
                <td>{{ point.ora }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="table-hint">
          <i class="fas fa-hand-pointer"></i>
          Seleziona un punto di transito per vedere i dettagli sui colli.
        </p>
      </div>

      <!-- ── RIGHT: detail panel ── -->
      <div class="td-right">

        <!-- Default: shipment summary -->
        <div *ngIf="!showDetails">

          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon"><i class="fas fa-cubes"></i></div>
              <h3 class="details-card-title">Contenuto</h3>
            </div>
            <div class="details-card-body">
              <div class="details-grid details-grid--metrics">
                <div class="details-item">
                  <span class="details-label">Peso totale</span>
                  <span class="details-value">{{ getTotalWeight() ? getTotalWeight() + ' kg' : '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Volume totale</span>
                  <span class="details-value">{{ getTotalVolume() ? getTotalVolume() + ' m³' : '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">N° colli</span>
                  <span class="details-value">{{ getNumeroColli() || '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Contenuto</span>
                  <span class="details-value">Ricambi BMW</span>
                </div>
              </div>
            </div>
          </div>

          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon"><i class="fas fa-truck"></i></div>
              <h3 class="details-card-title">Spedizione</h3>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Mittente</span>
                  <span class="details-value">{{ client?.clientName || '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Destinatario</span>
                  <span class="details-value">{{ dealers[0]?.dealerName || '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Indirizzo</span>
                  <span class="details-value">
                    {{ ((dealers[0]?.dealerOperatingAddressStreet || '') + ' ' + (dealers[0]?.dealerOperatingAddressCity || '')).trim() || '—' }}
                  </span>
                </div>
                <div class="details-item">
                  <span class="details-label">Tipo</span>
                  <span class="details-value">{{ getParcelType() || '—' }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Selected point details -->
        <div *ngIf="showDetails">

          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon"><i class="fas fa-map-marker-alt"></i></div>
              <h3 class="details-card-title">Punto Selezionato</h3>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Titolo</span>
                  <span class="details-value">{{ selectedPoint?.titolo || '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Stato</span>
                  <span class="sysmon-pill" [ngClass]="getStatusPillClass(selectedPoint?.status)">
                    {{ getStatusLabel(selectedPoint?.status) }}
                  </span>
                </div>
                <div class="details-item">
                  <span class="details-label">Data</span>
                  <span class="details-value">{{ selectedPoint?.data || '—' }}</span>
                </div>
                <div class="details-item">
                  <span class="details-label">Ora</span>
                  <span class="details-value">{{ selectedPoint?.ora || '—' }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="details-card" *ngIf="selectedPoint?.dettagli?.length">
            <div class="details-card-header">
              <div class="details-card-icon"><i class="fas fa-boxes"></i></div>
              <h3 class="details-card-title">Colli</h3>
            </div>
            <div class="sysmon-table-wrap">
              <table class="sysmon-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Collo</th>
                    <th>Descrizione</th>
                    <th>Evento</th>
                    <th>Data</th>
                    <th>Ora</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ev of selectedPoint?.dettagli">
                    <td><i [ngClass]="getStatusIconClasses(ev.evento)"></i></td>
                    <td class="td-mono td-strong">{{ ev.collo }}</td>
                    <td>{{ ev.descrizione }}</td>
                    <td>
                      <span class="sysmon-pill" [ngClass]="getStatusPillClass(ev.evento)">
                        {{ getStatusLabel(ev.evento) }}
                      </span>
                    </td>
                    <td>{{ ev.data }}</td>
                    <td>{{ ev.ora }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>
    </div>

  </ng-container>
</div>
